export default __webpack_public_path__ + "static/pulse-logo-whitetext-dbc7eedc42fe9da595129ea248640d3b.png";